import { cloneDeep } from "lodash";
import React, { useMemo } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import DatePickerWithDisplay from "@/components/UI/DatePickerWithDisplay";
import FormikInput from "@/components/UI/FormikInput";
import images from "@/utils/images";

import { ENCOUNTER_SCHEMA } from "../helpers/encounter-schema";

export function EncounterForm({
  dateClickHandler,
  encounterIndex,
  formikProps,
  optionClickHandler,
  removeEncounter,
  setFieldValue,
}) {
  // cloneDeep once per encounterIndex to allow mutation of onclick/onChange on schema elements
  const schema = useMemo(() => cloneDeep(ENCOUNTER_SCHEMA(encounterIndex)), [encounterIndex]);

  const encounter = formikProps.values.content.encounters[encounterIndex];
  const firstActiveEncounterIndex = formikProps.values.content.encounters.findIndex(
    (enc) => !enc.delete_marker,
  );

  return (
    <>
      {!encounter.delete_marker && (
        <div className="row m-0">
          <div className="border-bottom col-12 my-2" />
          <div
            className={
              encounterIndex === firstActiveEncounterIndex
                ? "d-none"
                : "w-100 d-flex justify-content-end"
            }
          >
            <Button2
              aria-label="Remove encounter"
              onPress={() => removeEncounter(formikProps, encounterIndex)}
              rawChildren
              variant="blank"
            >
              <img alt="" src={images("./icons/grey-x-circle.svg")} />
            </Button2>
          </div>
          {schema.map((formEl) => {
            if (formEl.elementConfig.type === "checkbox") {
              formEl.onclick = (name, option) =>
                optionClickHandler(name, option, encounter[formEl.relativeName], formikProps);

              const openTextOption = formEl.elementConfig.options.find((option) =>
                Object.hasOwn(option, "openText"),
              );

              if (openTextOption) {
                openTextOption.onChange = (e) =>
                  setFieldValue(
                    `content.encounters[${encounterIndex}].setting_other`,
                    e.target.value,
                  );
              }
            }

            if (formEl.elementType === "datePicker") {
              return (
                <div className={formEl.elementClasses} key={formEl.name}>
                  <DatePickerWithDisplay
                    dateClickHandler={dateClickHandler}
                    dateStr={encounter[formEl.relativeName]}
                    formEl={formEl}
                    formikProps={formikProps}
                  />
                </div>
              );
            } else {
              return (
                <div className={formEl.elementClasses} key={formEl.name}>
                  <FormikInput
                    errors={formikProps.errors}
                    formEl={formEl}
                    touched={formikProps.touched}
                  />
                </div>
              );
            }
          })}
        </div>
      )}
    </>
  );
}
